import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Footer from "./main/footer";
import Nav from "./main/nav";
import "../App.css";
import Header from "./main/header";
import { APIBaseURL } from "../Config";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler,
  CategoryScale,
  LinearScale,
} from "chart.js";
import axios from "axios";
import Swal from "sweetalert2";

ChartJS.register(
  ArcElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler,
  CategoryScale,
  LinearScale
);
export default function Index() {
  const [movesChartData, setMovesChartData] = useState(null);
  const [categoryChartData, setCategoryChartData] = useState(null);
  const [equipmentMoves, setEquipmentMoves] = useState([]);
  const [categoryNames, setCategoryNames] = useState([]);
  const [maintenanceChartData, setMaintenanceChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [Data, setData] = useState([]); // Full API Data
  const [weeklyData, setWeeklyData] = useState({
    labels: null,
    datasets: [],
  });
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const GetData = async () => {
    try {
      const response = await axios.get(`${APIBaseURL}/equipment/dashboard/data`);

      if (response.data && response.data.status == "success") {
        setData(response.data.data)

      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Something Went Error."

        })
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fetch Error",
        text: error.message || "Something went wrong while fetching data."

      })
    }

  }

  useEffect(() => {
    GetData();
  }, [])

  // Table Data fetch start

  const fetchEquipmentMoves = async () => {
    try {
      const response = await fetch(`${APIBaseURL}/equipment/dashboard/data`);
      const result = await response.json();

      if (result.status === "success") {
        const categoriesData = result.data.week_equipment_moves; // Get the categories data
        setEquipmentMoves(categoriesData); // Store the categories data in state
      }
    } catch (error) {
      console.error("Error fetching equipment moves:", error);
    }
  };

  useEffect(() => {
    fetchEquipmentMoves();
  }, []);

  //Table Data fetch end 

  useEffect(() => {
    const fetchEquipmentMoves = async () => {
      try {
        const response = await fetch(`${APIBaseURL}/equipment/dashboard/data`);
        const result = await response.json();

        if (result.status === "success") {
          const equipment = result.data.week_equipment_moves[0].equipments;
          const labels = equipment.map((item) => item.equipment_name);
          const moves = equipment.map((item) => parseInt(item.moves_count));

          setMovesChartData({
            labels,
            datasets: [
              {
                label: "Equipment Moves",
                data: moves,
                backgroundColor: ["#6A5ACD", "#FF69B4", "#4682B4", "#FFA500", "#ADFF2F"],
                borderColor: ["#5A4ACD", "#E060A4", "#3660A4", "#E09000", "#9DFF1F"],
                borderWidth: 1,
              },
            ],
          });
        }
      } catch (error) {
        console.error("Error fetching equipment moves:", error);
      }
    };

    const fetchEquipmentCategory = async () => {
      try {
        const response = await fetch(`${APIBaseURL}/equipment/dashboard/data`);
        const result = await response.json();

        if (result.status === "success") {
          // Extracting the weekly moves array
          const weeklyMoves = result.data.week_equipment_moves;

          // Initialize an empty object to hold the category counts
          const categoryCounts = {};

          // Iterate over each equipment list
          weeklyMoves.forEach(move => {
            const equipment = move.equipments;

            // Iterate over the equipment in each move
            equipment.forEach(item => {
              // Use the equipment category ID as the key to count
              const category = item.category_id;

              // Increment the count for this category
              if (categoryCounts[category]) {
                categoryCounts[category] += 1;
              } else {
                categoryCounts[category] = 1;
              }
            });
          });

          // Create labels and counts from the aggregated category data
          const labels = Object.keys(categoryCounts);
          const counts = Object.values(categoryCounts);

          // Update chart data
          setCategoryChartData({
            labels,
            datasets: [
              {
                label: "Equipment Categories",
                data: counts,
                backgroundColor: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"],
                // borderColor: ["#E04000", "#28B428", "#1870E0", "#E0C000", "#7A1AD2"],
                // borderWidth: 1,
              },
            ],
          });
        }
      } catch (error) {
        console.error("Error fetching equipment categories:", error);
      }
    };

    // Line chart data fetch

    const fetchMaintenanceDetails = async () => {
      try {
        const response = await fetch(`${APIBaseURL}/equipment/dashboard/data`);
        const result = await response.json();

        if (result.status === "success") {
          const maintenanceData = result.data.week_data;

          // Map over the week_data to get the day names and the total values for the chart
          const labels = maintenanceData.map((item) => item.day.trim()); // Trim any extra spaces
          const maintenanceCounts = maintenanceData.map((item) => parseInt(item.total)); // Convert total to an integer

          // Update the chart data
          setMaintenanceChartData({
            labels,
            datasets: [
              {
                label: "Weekly Maintenance Details",
                data: maintenanceCounts,
                borderColor: "#FF5733", // Orange-Red color for the line
                backgroundColor: "rgba(255, 87, 51, 0.2)", // Light background color for the chart
                borderWidth: 2,
                fill: true, // Fill the area under the line
                tension: 0.4, // Smooth curve for the line
              },
            ],
          });
        } else {
          console.error("Failed to fetch maintenance data: ", result.message);
        }
      } catch (error) {
        console.error("Error fetching maintenance details:", error);
      }
    };


    fetchEquipmentMoves();
    fetchEquipmentCategory();
    fetchMaintenanceDetails();
  }, []);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(200, 200, 200, 0.2)",
        },
      },
    },
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />


            <div className="content-wrapper">

              <div className="container-xxl flex-grow-1 container-p-y ">
                <div className="mb-3">
                  <Link to={'/che-report'} className="btn bg-label-primary me-4 ">CHE  Moves</Link>
                  {/* <Link to={'/reports/che-utilization'} className="btn  me-4 bg-label-primary">CHE  Utilization</Link> */}
                  <Link to={'/report-chart'} className="btn  me-4 btn btn-primary">Report Chart</Link>
                  <hr />
                </div>
                <div className="row gy-6 ">
                  <div className="col-md-12 col-lg-6">
                    <div className="card">
                      <div className="card-body text-nowrap">
                        <h6 className="card-title flex-wrap text-nowrap">
                          Equipment Moves
                        </h6>
                        <p className="mb-2"> Equipment Moves of Today</p>
                        {Data ? (
                          <h4 className="text-primary mb-1">{Data.tdy_moves}</h4>
                        ) : (
                          <p>Loading...</p>
                        )}
                        <Link
                          to={"/reports"}
                          className="btn btn-sm btn-primary"
                        >
                          View Reports
                        </Link>
                      </div>
                     
                    </div>
                  </div>


                  

                  <div className="col-lg-6 col-md-6">
                    <div className="d-flex flex-column gap-5">
                      <div className="card"
                        style={{ height: "177px" }}>
                        <div className="card-header"
                          style={{ paddingTop: "10px" }}>
                          <div className="d-flex justify-content-between">
                            <h5 className="mb-0">Weekly Overview</h5>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="mt-0">
                            <p className="mb-2" style={{ marginTop: "-10px" }}> Equipment Moves of This Week</p>
                            {Data ? (
                              <h4 className="text-primary mb-1">{Data.weekly_moves}</h4>
                            ) : (
                              <p>Loading...</p>
                            )}
                            <div className="d-grid mt-3 mt-md-4">
                              <Link
                                to={"/reports"}
                                className="btn btn-primary"
                                style={{ width: "120px", marginTop: "-10px", fontSize: "13px" }}
                                type="button"
                              >
                                View Details
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-xl-4 col-md-6">
                    <div className="card">
                      <div className="card-header">
                        <h5 className="text-primary text-center mb-0">
                          Total Moves of Last Week
                        </h5>
                      </div>
                      <div className="card-body">
                        {movesChartData && (
                          <Pie data={movesChartData} options={{ responsive: true, maintainAspectRatio: false }} />
                        )}
                      </div>
                    </div>
                  </div> */}
                  <div className="col-lg-6 col-md-6">
                    <div className="card " style={{ height: "350px" }}>
                      <div className="card-header">
                        <h5 className="text-primary text-center mb-0">
                          Total Equipment Category
                        </h5>
                      </div>
                      <div className="card-body">
                        {categoryChartData && (
                          <Pie data={categoryChartData} options={{ responsive: true, maintainAspectRatio: false }} />
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-xl-3 col-md-6">
                    <div className="row ">
                      <div className="col-md-12 mb-2">
                        <div className="card transparent-card border-1">
                          <div className="card-body">
                            <div className="d-flex align-items-center flex-wrap gap-2">
                              <div className="avatar me-2">
                                <div className="avatar-initial rounded shadow-xs bg-primary">
                                  <i className="ri-wubi-input ri-28px" />
                                </div>
                              </div>
                              <div className="card-info">
                                <p className="mb-0">RMG</p>
                                <div className="d-flex align-items-center">
                                  <h5 className="mb-0">286</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mb-2">
                        <div className="card transparent-card border-1">
                          <div className="card-body">
                            <div className="d-flex align-items-center flex-wrap gap-2">
                              <div className="avatar me-2">
                                <div className="avatar-initial rounded shadow-xs bg-info">
                                  <i className="ri-pinyin-input ri-28px" />
                                </div>
                              </div>
                              <div className="card-info">
                                <p className="mb-0">RTG</p>
                                <div className="d-flex align-items-center">
                                  <h5 className="mb-0">286</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mb-2">
                        <div className="card transparent-card border-1">
                          <div className="card-body">
                            <div className="d-flex align-items-center flex-wrap gap-2">
                              <div className="avatar me-2">
                                <div className="avatar-initial rounded shadow-xs bg-warning">
                                  <i className="ri-carousel-view ri-28px" />
                                </div>
                              </div>
                              <div className="card-info">
                                <p className="mb-0">RST</p>
                                <div className="d-flex align-items-center">
                                  <h5 className="mb-0">286</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className="col-lg-6 ">
                    <div className="card-group">
                      <div className="card mb-0">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                            <h5 className="m-0 me-2 text-primary">
                              Weekly Maintenance Details
                            </h5>
                            {/* <Link className="fw-medium" to={"/maintenance"}>
                              View all
                            </Link> */}
                          </div>
                          <div className="withdraw-content pt-2">
                            <Line data={maintenanceChartData} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-12">
                    <div className="card h-100 shadow-sm border-0">
                      <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between">
                        <h5 className="card-title m-0" style={{ color: "#6C5DD3" }}>Equipment Management</h5>
                      </div>
                      <div className="card-body p-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <table className="table table-bordered bg-white text-center" style={{ fontSize: "14px" }}>
                          <thead style={{ backgroundColor: "#e8ddff", color: "#6C5DD3" }}>
                            <tr className="table-primary">
                              <td>Id</td>
                              <td>Equipment Name</td>
                              <td>Moves Count</td>
                              <td>Category</td>
                            </tr>
                          </thead>
                          <tbody>
                            {equipmentMoves.map((category, categoryIndex) =>
                              category.equipments.map((item, index) => (
                                <tr
                                  key={`${categoryIndex}-${index}`}
                                  style={{ backgroundColor: index % 2 === 0 ? "#F8F9FA" : "white" }}
                                >
                                  <td>{item.id}</td>
                                  <td>{item.equipment_name}</td>
                                  <td>{item.moves_count}</td>
                                  <td>{category.name}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="col-xl-12">
                    <div className="card-group">
                      <div className="card mb-0">
                        <div className="card-body card-separator">
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                            <h5 className="m-0 me-2">Maintenance Details</h5>
                            <Link className="fw-medium" to={"/maintenance"}>
                              View all
                            </Link>
                          </div>
                          <div className="deposit-content">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Title</th>
                                  <th>Start Time</th>
                                  <th>End Time</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody className="table-border-bottom-0">
                                <tr className="table-primary">
                                  <td>
                                    <i className="ri-suitcase-2-line ri-22px text-danger me-4" />
                                    <span>Tours Project</span>
                                  </td>
                                  <td>23-07-2024 12:24 PM</td>
                                  <td>23-07-2024 1:24 PM</td>
                                  <td>
                                    <span className="badge rounded-pill bg-label-primary me-1">
                                      Active
                                    </span>
                                  </td>
                                </tr>
                                <tr className="table-secondary">
                                  <td>
                                    <i className="ri-bootstrap-fill ri-22px text-primary me-4" />
                                    <span>Latest Bootstrap</span>
                                  </td>
                                  <td>23-07-2024 12:24 PM</td>
                                  <td>23-07-2024 1:24 PM</td>
                                  <td>
                                    <span className="badge rounded-pill bg-label-primary me-1">
                                      Active
                                    </span>
                                  </td>
                                </tr>
                                <tr className="table-success">
                                  <td>
                                    <i className="ri-palette-fill ri-22px text-danger me-4" />
                                    <span>UI/UX Project</span>
                                  </td>
                                  <td>23-07-2024 12:24 PM</td>
                                  <td>23-07-2024 1:24 PM</td>
                                  <td>
                                    <span className="badge rounded-pill bg-label-primary me-1">
                                      Active
                                    </span>
                                  </td>
                                </tr>
                                <tr className="table-danger">
                                  <td>
                                    <i className="ri-bank-fill ri-22px text-primary me-4" />
                                    <span>Bank Project</span>
                                  </td>
                                  <td>23-07-2024 12:24 PM</td>
                                  <td>23-07-2024 1:24 PM</td>
                                  <td>
                                    <span className="badge rounded-pill bg-label-warning me-1">
                                      Pending
                                    </span>
                                  </td>
                                </tr>
                                <tr className="table-warning">
                                  <td>
                                    <i className="ri-shield-user-line ri-22px text-info me-4" />
                                    <span>Custom Security</span>
                                  </td>
                                  <td>23-07-2024 12:24 PM</td>
                                  <td>23-07-2024 1:24 PM</td>
                                  <td>
                                    <span className="badge rounded-pill bg-label-info me-1">
                                      Scheduled
                                    </span>
                                  </td>
                                </tr>
                                <tr className="table-info">
                                  <td>
                                    <i className="ri-leaf-fill ri-22px text-success me-4" />
                                    <span>Greenhouse Project</span>
                                  </td>
                                  <td>23-07-2024 12:24 PM</td>
                                  <td>23-07-2024 1:24 PM</td>
                                  <td>
                                    <span className="badge rounded-pill bg-label-info me-1">
                                      Scheduled
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div
                className="modal fade"
                id="Blocks-Modal"
                tabIndex={-1}
                style={{ display: "none" }}
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary pb-3">
                      <h5 className="modal-title" id="exampleModalLabel1">
                        Operation Type: Block
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="EquipmentType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="EquipmentType"
                            >
                              Equipment Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Block"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Block">
                              Block
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Equipment"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Equipment">
                              Equipment
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-secondary waves-effect"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-primary waves-effect waves-light"
                      >
                        Assign
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="Gate-Modal"
                tabIndex={-1}
                style={{ display: "none" }}
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary pb-3">
                      <h5 className="modal-title" id="exampleModalLabel1">
                        Operation Type: Gate
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="EquipmentType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="EquipmentType"
                            >
                              Equipment Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="TransactionType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="TransactionType"
                            >
                              Transaction Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Block"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Block">
                              Block
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Equipment"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Equipment">
                              Equipment
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-secondary waves-effect"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-primary waves-effect waves-light"
                      >
                        Assign
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="Rake-Modal"
                tabIndex={-1}
                style={{ display: "none" }}
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary pb-3">
                      <h5 className="modal-title" id="exampleModalLabel1">
                        Operation Type: Rake
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12 mb-4 d-flex gap-4">
                          <label
                            htmlFor=""
                            className="form-label me-5 fw-semibold"
                          >
                            Assign For:
                          </label>

                          <div className="form-check form-check-inline">
                            <input
                              name="Assign"
                              className="form-check-input"
                              type="radio"
                              value=""
                              id="Assign-Rake-Area"
                            />
                            <label
                              className="form-check-label"
                              for="Assign-Rake-Area"
                            >
                              Rake Area
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              name="Assign"
                              className="form-check-input"
                              type="radio"
                              value=""
                              id="Assign-Blocks"
                            />
                            <label className="form-check-label" for="Assign-Blocks">
                              Blocks
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="EquipmentType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="EquipmentType"
                            >
                              Equipment Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="TransactionType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="TransactionType"
                            >
                              Transaction Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Track-ID"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Track-ID">
                              Track ID
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Equipment"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Equipment">
                              Equipment
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-secondary waves-effect"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-primary waves-effect waves-light"
                      >
                        Assign
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="IntraYard-Modal"
                tabIndex={-1}
                style={{ display: "none" }}
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary pb-3">
                      <h5 className="modal-title" id="exampleModalLabel1">
                        Operation Type: Yard
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="EquipmentType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="EquipmentType"
                            >
                              Equipment Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="TransactionType"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label
                              className="form-label"
                              htmlFor="TransactionType"
                            >
                              Transaction Type
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Block"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Block">
                              Block
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              className="form-select"
                              id="Equipment"
                              required=""
                            >
                              <option value="">All</option>
                            </select>
                            <label className="form-label" htmlFor="Equipment">
                              Equipment
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-secondary waves-effect"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-primary waves-effect waves-light"
                      >
                        Assign
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
      </div>

      <div className="layout-overlay layout-menu-toggle" />
      <div className="drag-target" />
    </>
  );
}


